import {
  createContext,
  useState,
  useContext,
  useCallback,
  useEffect,
} from "react";
import { baseUrl } from "../utils/OtherUtils";
import { useAuthContext } from "./AuthContext";
import axios from "axios";
import Cookies from "js-cookie";

const CartContext = createContext();

const CartProvider = ({ children }) => {
  const { handleNotification, setIsAuth, isLoggedIn } = useAuthContext();
  const [isCart, setIsCart] = useState(false);
  const [cartData, setCartData] = useState([]);
  const [cartTotal, setCartTotal] = useState(0);
  const [collectionCharges, setCollectionCharges] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [platformFee, setPlatformFee] = useState(0);
  const [freeChargeDifference, setFreeChargeDifference] = useState(0);
  const [extraDiscount, setExtraDiscount] = useState(0);

  // Function to Fetch cart data
  const getCart = useCallback(async () => {
    // console.log("getCart called");
    // Get token and userId from cookies
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");

    if (!token || !userId) {
      console.error("Token or UserId not found in cookies");
      return;
    }

    try {
      // console.log("getCart called 2");
      // console.log("Token being sent:", token);

      // Define the URL for the request
      const url = `${baseUrl}/api/cart/get-cart/${userId}`;
      // console.log("getCart called 3");
      // Make the GET request to fetch the cart data
      

      const response = await axios.get(url, {
        headers: {
          // Include the token in the request headers for authentication
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("get cart 4")
      // console.log("extra data in cartCOntext", response?.data?.extraDiscount);
      console.log("getCart response", response.data);

      // Handle successful response
      if (response?.data?.success) {
        setCartData(response?.data?.cart);
        setCartTotal(response?.data?.totalAmount);
        setCollectionCharges(response?.data?.collectionCharges);
        setDiscount(response?.data?.discount);
        setExtraDiscount(response?.data?.extraDiscount);
        setPlatformFee(response?.data?.platformFee);
        setFinalAmount(response?.data?.finalAmount);
        setFreeChargeDifference(response?.data?.freeChargeDifference);
      } else {
        console.error("Error fetching cart:", response?.data?.message);
      }
    } catch (error) {
      console.error("Server error while fetching cart:", error);
    }
  }, []);

  const addCart = useCallback(
    async (productId, quantity = 1) => {
      console.log("addCart called")
      try {
        // Get the token and userId from cookies
        const token = Cookies.get("token");
        const userId = Cookies.get("userId");
        
        if (!token || !userId) {
          console.error("Token or UserId not found in cookies");
          setIsAuth(true);
          return;
        }

        // Validate the input
        if (!productId || !quantity || quantity < 1) {
          console.error(
            "Product ID and quantity are required, and quantity must be at least 1"
          );
          return;
        }

        // Set the Authorization header with the token
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        // Send POST request to add or update the product in the cart
        const response = await axios.post(
          `${baseUrl}/api/cart/add-cart/${userId}`,
          { productId, quantity },
          config
        );
        // console.log("response in addCart", response);
        // Handle the response (cart data)


        getCart();

        return response.data;
      } catch (error) {
        console.error(
          "Error adding/updating product in the cart",
          error.response ? error.response.data : error.message
        );
        handleNotification(
          error?.response?.data?.success,
          error?.response?.data?.message
        );
      }
    },
    [getCart]
  );

  // Function to remove cart
  const removeCart = useCallback(
    async (productId) => {
      try {
        // Get the token and userId from cookies
        const token = Cookies.get("token");
        const userId = Cookies.get("userId");

        if (!token || !userId) {
          console.error("Token or UserId not found in cookies");
          return;
        }

        // Validate the input
        if (!productId) {
          console.error("Product ID is required");
          return;
        }

        // Set the Authorization header with the token
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        // Send DELETE request to remove the product from the cart
        const response = await axios.delete(
          `${baseUrl}/api/cart/remove-cart/${userId}`,
          {
            data: { productId },
            headers: config.headers,
          }
        );

        // Handle the response (cart data)

        if (response?.data?.success) {
          getCart();
        }

        return response.data;
      } catch (error) {
        console.error(
          "Error removing product from cart",
          error.response ? error.response.data : error.message
        );
      }
    },
    [getCart]
  );

  // Function to remove cart
  const clearCart = useCallback(async () => {
    try {
      // Get the token and userId from cookies
      const token = Cookies.get("token");
      const userId = Cookies.get("userId");

      if (!token || !userId) {
        console.error("Token or UserId not found in cookies");
        return;
      }

      // Set the Authorization header with the token
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // Send DELETE request to remove the product from the cart
      const response = await axios.delete(
        `${baseUrl}/api/cart/clear-cart/${userId}`,
        {
          headers: config.headers,
        }
      );

      // Handle the response (cart data)


      if (response?.data?.success) {
        getCart();
      }

      return response.data;
    } catch (error) {
      console.error(
        "Error removing products from cart",
        error.response ? error.response.data : error.message
      );
    }
  }, [getCart]);

  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");

    if (token && userId && isLoggedIn) {
      getCart();
    }
  }, [getCart, isLoggedIn]);

  return (
    <CartContext.Provider
      value={{
        isCart,
        getCart,
        addCart,
        removeCart,
        clearCart,
        setIsCart,
        cartData,
        cartTotal,
        collectionCharges,
        discount,
        platformFee,
        finalAmount,
        freeChargeDifference,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCartContext = () => useContext(CartContext);

export default CartProvider;
